import BigNumber from "bignumber.js";
import dayjs from "dayjs";

export function calculateAPRFees(
  borrowAPRRaw,
  amountETHBorrowed,
  aprStartUnix
) {
  const diffSeconds = new BigNumber(dayjs().unix()).minus(
    aprStartUnix
  );
  return diffSeconds
    .times(borrowAPRRaw)
    .times(amountETHBorrowed)
    .div(10000)
    .div(new BigNumber(60).times(60).times(24).times(365).toFixed())
    .toFixed();
}
